import { postReviewerEvents } from '../api/postReviewerEvents';
import { pendingBatchStorage } from './pendingBatchStorage';

// Replays events left behind by a session that ended badly — the tab was
// discarded while backgrounded, the browser was killed, the phone died, or the
// network never came back before the reviewer closed the page.
//
// Called on mount of the viewer flow. Spec §12 settles that a returning reviewer
// starts clean with a new reviewer_id rather than resuming, so this does NOT
// restore any session state; it only posts the orphaned events under the
// reviewer id they were originally recorded against, then clears them. The
// server's client_seq dedup makes that safe even if the events had in fact
// already landed.
export async function drainOrphanedBatches(exceptReviewerId: string | null): Promise<void> {
  for (const reviewerId of pendingBatchStorage.listReviewerIds()) {
    if (reviewerId === exceptReviewerId) continue;
    const session = pendingBatchStorage.read(reviewerId);
    if (!session) {
      pendingBatchStorage.clear(reviewerId);
      continue;
    }
    if (session.reactions.length === 0 && session.samples.length === 0) {
      pendingBatchStorage.clear(reviewerId);
      continue;
    }
    try {
      await postReviewerEvents(reviewerId, {
        reactions: session.reactions,
        samples: session.samples
      });
      pendingBatchStorage.clear(reviewerId);
    } catch {
      // Still offline, or the reviewer row is gone. Leave it in place; the next
      // page load will try again. Dropping it here would be the one way to
      // actually lose the data this whole mechanism exists to protect.
    }
  }
}
